import { gql } from '@src/__generated__';

export const SAVE_QUESTION_STATES = gql(`
  mutation SaveQuestionState(
    $id: ID
    $tripProfileId: ID!
    $questionId: ID!
    $questionType: String!
    $parentQuestionId: ID!
    $rank: [ID]!
    ) {
    saveQuestionState(
      id: $id
      tripProfileId: $tripProfileId
      questionId: $questionId
      questionType: $questionType
      parentQuestionId: $parentQuestionId
      rank: $rank
    ) {
      id
      tripProfileId
      questionId
      questionType
      parentQuestionId
      rank
    }
  }
`);

export const SAVE_ALL_QUESTION_STATES = gql(`
  mutation SaveAllQuestionStates(
    $questionsState: [questionStateInput!]!
  ) {
    saveAllQuestionsState(
      questionsState: $questionsState
    ) {
      id
      tripProfileId
      questionId
      questionType
      parentQuestionId
      rank
    }
  }
`);
